import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { APP_VERSION } from "../lib/version";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white px-4 sm:px-6 lg:px-8 py-4 mt-auto" data-testid="app-footer">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-500">
          <span className="font-mono text-slate-400" data-testid="app-version">Fabriko v{APP_VERSION}</span>
          <Link to="/mentions-legales" className="hover:text-navy transition-colors" data-testid="footer-mentions">Mentions légales</Link>
          <Link to="/cgv" className="hover:text-navy transition-colors" data-testid="footer-cgv">CGV</Link>
          <Link to="/confidentialite" className="hover:text-navy transition-colors" data-testid="footer-confidentialite">Confidentialité</Link>
          <Link to="/accessibilite" className="hover:text-navy transition-colors" data-testid="footer-accessibilite">Accessibilité</Link>
          <Link to="/assistant" className="inline-flex items-center gap-1 hover:text-sky-600 transition-colors" data-testid="footer-assistant">
            <Sparkles className="w-3.5 h-3.5" /> Assistant IA
          </Link>
        </div>
        <p className="text-[11px] text-slate-400">
          Développé par <span className="font-medium text-slate-500">Besson Solutions</span> — Propriétaire : La Sellerie Tout Simplement SAS
        </p>
      </div>
    </footer>
  );
}
